/**
 * Add trigger to `this.triggers`
 * @param {MainClassProps} main
 * @param {TriggerProps | null} [trigger]
 */
const addToLocalTriggers = (main, trigger) => {
  if (!trigger) {
    return;
  }

  const type = /** @type {GlobalTriggersListProps} */ (trigger?.get("type"));
  const name = /** @type {String} */ (trigger.get("name"));
  const triggers = /** @type {MainLocalTriggersProps} */ (main.triggers);

  if (!triggers.has(type)) {
    triggers?.set(type, []);
  }

  triggers.get(type)?.push(name);
};

export default addToLocalTriggers;
